export const MANUAL_OPTION_VALUE = 'MANUAL_OPTION_VALUE';
export const TK_OPTION_VALUE = 'TK_OPTION_VALUE';
